import posthog from "posthog-js";

export function initPostHog() {
  const apiKey = import.meta.env.POSTHOG_API_KEY;

  if (!apiKey) return;

  posthog.init(apiKey, {
    api_host: import.meta.env.POSTHOG_HOST ?? "https://us.i.posthog.com",
    // pageview_extended is fired manually by RouteAnalyticsTracker so that
    // every page event carries last_visited_page, most_visited_page_ever, and
    // session_frequency. Disable the default autocapture to avoid duplicates.
    capture_pageview: false,
    capture_pageleave: true,
    persistence: "localStorage+cookie",
    // autocapture is enabled (PostHog default). It powers $rageclick and
    // $dead_click detection on CTAs without any extra instrumentation.
    // Monitor rage clicks specifically on the "Book Now" and submit buttons
    // in PostHog → Activity → Rage Clicks.
  });
}
